// // src/DownloadCSV.js
// import React from "react";
// import { Button } from "antd";
// import { CSVLink } from "react-csv";

// export const CSVFile = ({ data, filename, buttonText }) => {
//   return (
//     <CSVLink data={data} filename={filename}>
//       <Button>{buttonText}</Button>
//     </CSVLink>
//   );
// };


